import { getWarrantyUrl } from '@catalogo/core-helpers/url';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const getUrl = (
  productId,
  currentSku,
  sellerStoreId,
  buyTogether,
  productQty = 1,
  servicePDPinfoForWarranty
) => {
  const isBuyTogetherSelected = buyTogether?.buyTogetherVIP?.active ?? false;
  const servicesPDP = servicePDPinfoForWarranty;

  if (isBuyTogetherSelected) {
    const sku = buyTogether?.buyTogetherVIP?.sku;
    const storeId = buyTogether?.buyTogetherVIP?.sellerId;
    const extra = [{ sku, storeId, servicesPDP }];
    return getWarrantyUrl(productId, currentSku, sellerStoreId, productQty, extra);
  }
  const extraServicesPDP = servicesPDP ? [{ servicesPDP }] : [];

  return getWarrantyUrl(productId, currentSku, sellerStoreId, productQty, extraServicesPDP);
};

export const selectButtonFlow = (isO2O, sellerStoreId, currentSku, warrantyUrl, experiment) => {
  if (isO2O && !sellerStoreId) {
    return '#modal-select-store';
  }

  const hasDiffs = !!currentSku?.diffs;
  const isUsed = currentSku?.offers?.result?.[0]?.condition === 'USED';
  if (hasDiffs || isUsed) {
    return experiment === 'NEW' ? '#modal-confirm-variation-new' : '#modal-confirm-variation';
  }

  return warrantyUrl;
};

export const getBuyButtonText = isPreSale => (isPreSale ? 'comprar na pré-venda' : 'comprar');

export const sendMetrics = (
  dispatchMetrics,
  selectQuantityWasUsed,
  servicePDPinfoForWarranty,
  url,
  setCookie,
  products,
  history
) => () => {
  if (!selectQuantityWasUsed && !servicePDPinfoForWarranty) {
    dispatchMetrics('addToCart', {
      action: 'add',
      category: 'product',
      products,
    });
  }

  if (servicePDPinfoForWarranty) {
    dispatchMetrics('addToCart', {
      category: 'pdp-produtos-adjacentes',
      action: 'adicionar-produto',
      label: 'combo',
      products,
    });
  }

  if (products?.[0]?.hasProggresiveDiscount) {
    setCookie('catalogTestAB', 'showDiscountProgressive');
  }

  if (url?.startsWith('/')) {
    window.location.href = url;
  } else {
    replaceUrlParams(history, url, false, { servicePDPinfoForWarranty })();
  }
};
